var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Quill from 'quill';
var inline = Quill.import('blots/inline');
var UrlOptions = /** @class */ (function () {
    function UrlOptions() {
        this.label = null;
        this.url = null;
    }
    return UrlOptions;
}());
export { UrlOptions };
var UrlFormat = /** @class */ (function (_super) {
    __extends(UrlFormat, _super);
    function UrlFormat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UrlFormat.create = function (options) {
        var node = _super.create.call(this, options.label);
        node.setAttribute('href', this.addProtocolIfDoesntExist(options.url));
        node.setAttribute('title', options.label);
        node.classList.add('text-company-link');
        if (options.isNewWindow) {
            node.setAttribute('target', '_blank');
        }
        return node;
    };
    UrlFormat.addProtocolIfDoesntExist = function (url) {
        return !/^(http:|https:)/.test(url) ? "http://" + url : url;
    };
    UrlFormat.formats = function (node) {
        return {
            label: node.getAttribute('title'),
            url: node.getAttribute('href'),
            isNewWindow: (node.getAttribute('target') === '_blank'),
        };
    };
    UrlFormat.prototype.format = function (name, value) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var domNode = this.domNode;
        if (name === 'link' && value) {
            domNode.setAttribute('href', value.url);
            domNode.setAttribute('title', value.label);
            domNode.classList.add('text-company-link');
            if (value.isNewWindow) {
                domNode.setAttribute('target', '_blank');
            }
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    UrlFormat.blotName = 'url';
    UrlFormat.tagName = 'A';
    return UrlFormat;
}(inline));
export { UrlFormat };
